
<template>
  <div class="footer">
    <div class="section">
      <div class="footer_g">
        <div class="f_head">
          <span class="f_logo"></span>
        </div>
        <div class="f_menu">
          <a href="https://gifted-banjo-553.notion.site/2025-02-05-443bbb7560c04b12a5c257344abc521b" target="_blank">서비스 이용약관</a>
          <span class="foot_vertical">|</span>
          <a href="https://gifted-banjo-553.notion.site/2025-01-27-f9bd44d6d809443682effd2356f2eacc" target="_blank" class="person_bold">개인정보처리방침</a>
          <span class="foot_vertical">|</span>
          <a href="https://gifted-banjo-553.notion.site/2025-01-27-ef00373387ec470e99855aa652851e30" target="_blank" class="person_bold">위치기반 서비스 이용약관</a>
        </div>
        <div class="f_company">
          <span class="company_name">(주)카카오 VX</span>
          <span class="company_text">
            공동대표 : 문태식, 김창준 &nbsp;&nbsp; 사업자등록번호: 144-81-03460<br>
            주소: 경기도 성남시 분당구 판교로255번길 68(삼평동) <br class="m-br" /><span>유비쿼스빌딩 4F</span><br>
            메일: trangglecs@kakaovx.com<br>
            통신판매업신고번호 : 2012-경기성남-1139
          </span>
        </div>
      </div>
    </div>
    <div class="copyright">Copyright ⓒ Kakao VX Corp. All rights reserved</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
